import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { CardModule } from 'primeng/card';
import { AboutGroups } from './model/about-group';
import { AboutSectionComponent } from './about-section/about-section.component';
import { AppService } from 'app/app.service';
import { SignalsService } from '@shared/services/signals/signals.service';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from '@shared/components/breadcrumb/breadcrumb.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-about',
    imports: [
        CommonModule,
        CardModule,
        AboutSectionComponent
    ],
    templateUrl: './about.component.html',
    styleUrl: './about.component.scss'
})
export class AboutComponent implements OnInit, OnDestroy {

  constructor(
    public appService: AppService,
    private signalService: SignalsService,
    private breadcrumbService: BreadcrumbService,
  ) {}

  adminSub!: Subscription;

  version: string = `${environment.appVersion}`;
  generalDataGroups?: AboutGroups;
  faqDataGroups?: AboutGroups;
  legalDataGroups?: AboutGroups;
  isAdmin: boolean = false;

  ngOnInit(): void {
    this.breadcrumbService.removeBreadcrumb([
      'Version Details', 
      'Feedback', 
      'Disclaimer',
      'General FAQ',
      'Flights FAQ',
      'Analyze FAQ',
      'Search FAQ',
      'Export FAQ',
      'Admin FAQ'
    ]);

    this.adminSub = this.signalService.isAdminRole$.subscribe( (isAdmin) => {
      this.isAdmin = isAdmin;
      this.generalDataGroups = this.getGeneralDataGroups();
      this.faqDataGroups = this.getFaqDataGroups();
      this.legalDataGroups = this.getLegalDataGroups();
    });
  }

  getGeneralDataGroups(): AboutGroups {
    return {
     title: 'General',
     aboutMenuGroups: [
       {
         groupsItems: [
           {
             name: 'Version Details',
             type: 'static',
             icon: 'pi pi-info-circle',
             iconColor: 'background: var(--p-blue-500)',
             path: 'version'
           },
           {
             name: 'Feedback',
             type: 'static',
             icon: 'pi pi-at',
             iconColor: 'background: var(--p-green-500)',
             path: 'feedback'
           }
         ]
       }
     ]
   }
  }

  getFaqDataGroups(): AboutGroups {

    if (this.isAdmin) {
      return {
        title: 'Faq',
        aboutMenuGroups: [
          {
            groupsItems: [
              {
                name: 'General',
                type: 'static',
                icon: 'pi pi-question-circle',
                iconColor: 'background: var(--p-red-500)',
                path: 'general'
              },
              {
                name: 'Flights',
                type: 'static',
                icon: 'pi pi-list',
                iconColor: 'background: var(--p-slate-500)',
                path: 'flights'
              },
              {
                name: 'Analyze',
                type: 'static',
                icon: 'pi pi-history',
                iconColor: 'background: var(--p-primary-600)',
                path: 'analyze'
              },
              {
                name: 'Search',
                type: 'static',
                icon: 'pi pi-search',
                iconColor: 'background: var(--p-indigo-500)',
                path: 'search'
              },
              {
                name: 'Export',
                type: 'static',
                icon: 'pi pi-file-export',
                iconColor: 'background: var(--p-blue-500)',
                path: 'export'
              },
              {
                name: 'Admin',
                type: 'static',
                icon: 'pi pi-users',
                iconColor: 'background: var(--p-orange-500)',
                path: 'admin'
              }
            ]
          }
        ]
      }
    }
    else {
      return {
        title: 'Faq',
        aboutMenuGroups: [
          {
            groupsItems: [
              {
                name: 'General',
                type: 'static',
                icon: 'pi pi-question-circle',
                iconColor: 'background: var(--p-red-500)',
                path: 'general'
              },
              {
                name: 'Flights',
                type: 'static',
                icon: 'pi pi-list',
                iconColor: 'background: var(--p-slate-500)',
                path: 'flights'
              },
              {
                name: 'Analyze',
                type: 'static',
                icon: 'pi pi-history',
                iconColor: 'background: var(--p-primary-600)',
                path: 'analyze'
              },
              {
                name: 'Search',
                type: 'static',
                icon: 'pi pi-search',
                iconColor: 'background: var(--p-indigo-500)',
                path: 'search'
              },
              {
                name: 'Export',
                type: 'static',
                icon: 'pi pi-file-export',
                iconColor: 'background: var(--p-blue-500)',
                path: 'export'
              },
              
            ]
          }
        ]
      }
    }
  }

  getLegalDataGroups(): AboutGroups {
    return {
      title: 'Application',
      aboutMenuGroups: [
        {
          groupsItems: [
            {
              name: 'Legal Disclaimer',
              type: 'static',
              disabled: false,
              icon: 'pi pi-lock',
              iconColor: 'background: var(--p-blue-500)',
              path: 'disclaimer'
            }
          ]
        }
      ]
    }
  }

  ngOnDestroy(): void {
    this.adminSub?.unsubscribe();
  }

}
